import React, {Component} from 'react';
import {Row, Card, CardBody, Nav, NavItem, NavLink, TabPane, TabContent} from 'reactstrap';
import {Colxx} from '../../components/common/CustomBootstrap';
import RegularTransactions from "./Regular";
import BankDeposits from "./BankDeposits";
import i18n from "../../services/i18n";
import classnames from "classnames";
import Rbac from "../../components/Rbac";
import IdBaseDeposits from "../IdBaseDeposits";

class Transactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
    };
  }

  toggle = tabIndex => {
    this.setState({
      activeTab: tabIndex,
    });
  };

  render() {
    const {userId, ref, filteredTransactionId} = this.props;
    const {activeTab} = this.state;
    return (
      <Row>
        <Colxx xxs="12" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <Nav tabs>
                <Rbac permission="view_user-deposits">
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === 0 })}
                      onClick={() => {this.toggle(0);}}>
                    <span className="text-one cursor-pointer">
                      {i18n.t('Deposits & Withdraws')}
                    </span>
                    </NavLink>
                  </NavItem>
                </Rbac>
                <Rbac permission="view_bank-deposit">
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === 1 })}
                      onClick={() => {this.toggle(1);}}>
                    <span className="text-one cursor-pointer">
                      {i18n.t('Bank Deposits')}
                    </span>
                    </NavLink>
                  </NavItem>
                </Rbac>
                <Rbac permission="view_bank-deposit">
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === 2 })}
                      onClick={() => {this.toggle(2);}}>
                    <span className="text-one cursor-pointer">
                      {i18n.t('Id Base Deposit')}
                    </span>
                    </NavLink>
                  </NavItem>
                </Rbac>
              </Nav>
              <Rbac permission="view_user-deposits">
                <TabContent activeTab={activeTab}>
                  <TabPane tabId={0}>
                    <RegularTransactions
                      ref={ref}
                      userId={userId}
                      filteredTransactionId={filteredTransactionId}
                    />
                  </TabPane>
                </TabContent>
              </Rbac>
              <Rbac permission="view_bank-deposit">
                <TabContent activeTab={activeTab}>
                  <TabPane tabId={1}>
                    <BankDeposits userId={userId}/>
                  </TabPane>
                </TabContent>
              </Rbac>
              <Rbac permission="view_bank-deposit">
                <TabContent activeTab={activeTab}>
                  <TabPane tabId={2}>
                    <IdBaseDeposits userId={userId}/>
                  </TabPane>
                </TabContent>
              </Rbac>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default Transactions;
